import { indexOf } from 'lodash'
import { keepMediaPositionInBoundaries } from 'redux/navigation/selectors'
import { getMediaThreshold } from 'redux/configuration/selectors'

export const isFetchedMedia = (state, index) => indexOf(state.fetchingMedia, index) !== -1

export const fetchingMediaBoundaries = (state, position) => {
    
    const batchSize = getMediaThreshold(state)
    
    return {
        start: keepMediaPositionInBoundaries(state, position - batchSize),
        end: keepMediaPositionInBoundaries(state, position + batchSize),
    }
}
